module.exports = "img/flags/BG.cf8a030.png";